// extracted by mini-css-extract-plugin
module.exports = {"hi":"HeaderIndicator_hi__2-SH_"};